"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SasCallbackResponse = exports.SasFileResponse = exports.StudyDwDownloadResponse = exports.RequestStudyDwHistoryResponse = exports.GetStudyDwCommentResponse = exports.StudyCommentExportConds = exports.StudyDwCommentExportPayload = exports.GetStudyDwAuditTrailResponse = exports.AuditTrailExportConds = exports.AuditTrailExportPayload = exports.DwExportCrfEcoaExtractionMode = exports.ExportStudyDwBlankCrfsResponse = exports.GetStudyDwBlankCrfResponse = exports.ExportStudyDwDbSpecsResponse = exports.DwDbSpecExportOpts = exports.ExportStudyDwDatasetsResponse = exports.GetStudyDwDatasetResponse = exports.DatasetExportConds = exports.DatasetExportPayload = exports.PdfGenerateEngine = exports.DataWarehouseExportFormat = void 0;
var DataWarehouseExportFormat;
(function (DataWarehouseExportFormat) {
    DataWarehouseExportFormat["Excel"] = "XLS";
    DataWarehouseExportFormat["CSV"] = "CSV";
    DataWarehouseExportFormat["PDF"] = "PDF";
    DataWarehouseExportFormat["SAS"] = "SAS";
})(DataWarehouseExportFormat = exports.DataWarehouseExportFormat || (exports.DataWarehouseExportFormat = {}));
var PdfGenerateEngine;
(function (PdfGenerateEngine) {
    PdfGenerateEngine["Chrome"] = "CHROME";
    PdfGenerateEngine["Prince"] = "PRINCE";
})(PdfGenerateEngine = exports.PdfGenerateEngine || (exports.PdfGenerateEngine = {}));
class DatasetExportPayload {
}
exports.DatasetExportPayload = DatasetExportPayload;
class DatasetExportConds {
}
exports.DatasetExportConds = DatasetExportConds;
class GetStudyDwDatasetResponse {
}
exports.GetStudyDwDatasetResponse = GetStudyDwDatasetResponse;
class ExportStudyDwDatasetsResponse {
}
exports.ExportStudyDwDatasetsResponse = ExportStudyDwDatasetsResponse;
class DwDbSpecExportOpts {
}
exports.DwDbSpecExportOpts = DwDbSpecExportOpts;
class ExportStudyDwDbSpecsResponse {
}
exports.ExportStudyDwDbSpecsResponse = ExportStudyDwDbSpecsResponse;
// Blank CRFs
class GetStudyDwBlankCrfResponse {
}
exports.GetStudyDwBlankCrfResponse = GetStudyDwBlankCrfResponse;
class ExportStudyDwBlankCrfsResponse {
}
exports.ExportStudyDwBlankCrfsResponse = ExportStudyDwBlankCrfsResponse;
var DwExportCrfEcoaExtractionMode;
(function (DwExportCrfEcoaExtractionMode) {
    DwExportCrfEcoaExtractionMode["INCLUDE_ECOA"] = "INCLUDE_ECOA";
    DwExportCrfEcoaExtractionMode["EXCLUDE_ECOA"] = "EXCLUDE_ECOA";
    DwExportCrfEcoaExtractionMode["EXTRACT_ECOA"] = "EXTRACT_ECOA";
})(DwExportCrfEcoaExtractionMode = exports.DwExportCrfEcoaExtractionMode || (exports.DwExportCrfEcoaExtractionMode = {}));
/** @deprecated AuditTrail Export 모듈 변경 (XLSX -> exceljs) */
class AuditTrailExportPayload {
}
exports.AuditTrailExportPayload = AuditTrailExportPayload;
class AuditTrailExportConds {
}
exports.AuditTrailExportConds = AuditTrailExportConds;
class GetStudyDwAuditTrailResponse {
}
exports.GetStudyDwAuditTrailResponse = GetStudyDwAuditTrailResponse;
class StudyDwCommentExportPayload {
}
exports.StudyDwCommentExportPayload = StudyDwCommentExportPayload;
class StudyCommentExportConds {
}
exports.StudyCommentExportConds = StudyCommentExportConds;
class GetStudyDwCommentResponse {
}
exports.GetStudyDwCommentResponse = GetStudyDwCommentResponse;
class RequestStudyDwHistoryResponse {
}
exports.RequestStudyDwHistoryResponse = RequestStudyDwHistoryResponse;
class StudyDwDownloadResponse {
}
exports.StudyDwDownloadResponse = StudyDwDownloadResponse;
class SasFileResponse {
}
exports.SasFileResponse = SasFileResponse;
class SasCallbackResponse {
}
exports.SasCallbackResponse = SasCallbackResponse;
//# sourceMappingURL=studyDw.js.map